module.exports = __webpack_public_path__ + "static/img/robot-zucheng.4da96e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot-zucheng.png
// module id = kDYC
// module chunks = 1